// The Gistly brand glyph — an open book with a sparkle, matching the LINE OA
// profile icon. Defaults to a warm two-tone treatment that stays visible on the
// white app-chrome tile; the marketing site can pass its own ink tones.
export function GistlyMark({
  size = 24,
  page = "#b15b3c",
  facing = "#ffe4d9",
  spine = "#e8a48f"
}: {
  size?: number;
  page?: string;
  facing?: string;
  spine?: string;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      {/* left page */}
      <path
        d="M50 31 C41 25 26 24 18 27 C16.5 27.5 15.5 29 15.5 30.6 L15.5 70 C15.5 71.8 17 73.2 18.8 73 C26 72.2 41 73 50 78 Z"
        fill={page}
      />
      {/* right page (softer tone to hint an open book) */}
      <path
        d="M50 31 C59 25 74 24 82 27 C83.5 27.5 84.5 29 84.5 30.6 L84.5 70 C84.5 71.8 83 73.2 81.2 73 C74 72.2 59 73 50 78 Z"
        fill={facing}
      />
      {/* spine */}
      <path d="M50 31 L50 78" stroke={spine} strokeWidth="3" strokeLinecap="round" />
      {/* sparkle */}
      <path
        d="M76 17 c1.2 4.6 2.2 5.6 6.8 6.8 c-4.6 1.2 -5.6 2.2 -6.8 6.8 c-1.2 -4.6 -2.2 -5.6 -6.8 -6.8 c4.6 -1.2 5.6 -2.2 6.8 -6.8 z"
        fill={page}
      />
    </svg>
  );
}
